import { call, put } from 'redux-saga/effects';
import { appDataService } from '../../appsync-client';

interface RequestDataFlow {
  query: any;
  successType: string;
  errorType: string;
  type?: string;
}

const ApiRequest = (query: any, variables = {}) => {
  return appDataService.client.query({query, variables: variables})
}

export const requestData = (query: any, successType: string, errorType: string) => {
  return SagaRequestDataFlowFactory.getData({
    query: query,
    successType: successType,
    errorType: errorType,
  })
};

export class SagaRequestDataFlowFactory {
  static getData = ({
    query,
    successType,
    errorType
  }: RequestDataFlow) => {
    return function* (variables: any = {}, onComplete?: (result: APICallResult) => any) {
      try {
        const response = yield call(ApiRequest, query, variables);
        if (response) {
          yield put({ type: successType, data: response.data });
          if (onComplete) {
            onComplete({ data: response.data });
          }
        }
      } catch (error) {
        yield put({ type: errorType, error });
        if (onComplete) {
          onComplete({ error });
        }
      }
      return true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/flows/request-data.ts